import { crossSitePaths } from './cross-site-navigation-paths';

const evaluatedPaths = new Map();

export const clearEvaluated = () => {
	evaluatedPaths.clear();
};

const matchesStarting = (path, startingMatcher) => {
	for (const matcher of startingMatcher) {
		if (path.startsWith(matcher)) {
			return true;
		}
	}
	return false;
};

export const isInternalNavigationPath = (path) => {
	if (!path) {
		// Empty paths are assumed internal
		return true;
	}

	const evaluated = evaluatedPaths.get(path);
	if (evaluated !== undefined) {
		return evaluated;
	}

	const pathCompare = path.startsWith('/') ? path : `/${path}`;

	let isInternal = true;
	if (crossSitePaths.exactGatsby.has(pathCompare)) {
		isInternal = true;
	} else if (crossSitePaths.exactNext.has(pathCompare)) {
		isInternal = false;
	} else if (matchesStarting(pathCompare, crossSitePaths.startingGatsby)) {
		isInternal = true;
	} else if (matchesStarting(pathCompare, crossSitePaths.startingNext)) {
		isInternal = false;
	}
	evaluatedPaths.set(path, isInternal);

	return isInternal;
};
